module.exports = __webpack_public_path__ + "static/img/1_5.4ade6da9.jpg";